// Third party libraries
import { format } from 'date-fns';
import { utcToZonedTime } from 'date-fns-tz';

// Constants
import { FREQUENCY_API_CODE } from '@/app/constants/subscription-constants';
import { DOG_PURCHASE_STATUS } from '@/app/constants/dog-purchase';
import { PUPPY_SELL_STATUS, PAYMENT_FREQUENCY_DISPLAY } from '@/app/constants/status-constants';

export default {
	install(Vue) {
		// Plugin: vue2-filters
		// Filters: capitalize, uppercase, lowercase, capitalize({ onlyFirstLetter: true }), placeholder, truncate, currency, pluralize, ordinal, limitBy, filterBy, find, orderBy
		// Link: https://www.npmjs.com/package/vue2-filters

		// TEXT AND NUMBERS
		// numbers to string
		Vue.filter('numbersToString', number => {
			if (number === 0 || number === '0') {
				return 'No';
			} else if (number === 1 || number === '1') {
				return 'Yes';
			}
		});

		// round numbers
		Vue.filter('roundNumbers', (number,fixPoint) => {
			return parseFloat(number.toFixed(fixPoint||2));
		});

		// round number
		Vue.filter('roundNumber', (number,fixPoint) => {
			return parseFloat(number).toFixed(fixPoint||2);
		});

		// price formal
		Vue.filter('displayPrice', (number,fixPoint) => {
			if (number) {
				return parseFloat(number).toFixed(fixPoint||2);
			} else {
				return '0.00';
			}
		});
		// SIZE
		// format size 
		Vue.filter('formatSize', size => {
			// 1TB
			if (size > 1024 * 1024 * 1024 * 1024) {
				return (size / 1024 / 1024 / 1024 / 1024).toFixed(2) + ' TB'
			// 1GB
			} else if (size > 1024 * 1024 * 1024) {
				return (size / 1024 / 1024 / 1024).toFixed(2) + ' GB'
			// 1MB
			} else if (size > 1024 * 1024) {
				return (size / 1024 / 1024).toFixed(2) + ' MB'
			// 1KB
			} else if (size > 1024) {
				return (size / 1024).toFixed(2) + ' KB'
			}
			// 1B
			return size.toString() + ' B'
		});

		
		// LIST
		// array to list
		Vue.filter('arrayToList', (array, separator) => {
			if (array && array.length > 0) {
				if (typeof array !== 'string') {
					return array.join(`${separator} `);
				} else {
					return array;
				}
			}
		});

		// date and time display format
		Vue.filter('formatDate', date => {
			if (date) {
				return format(new Date(date), 'dd-MMM-yyyy');
			}
		});

		// status display format
		Vue.filter('showStatusTextAdmin', status => {
			if (status) {
				switch (status) {
					case 'A':
						return 'Removed Content';
					case 'I':
						return 'Remained Content';
					default:
						return 'Pending Request';
				}
			}
		});

		// translate price frequency
		Vue.filter('translateFrequency', fqy => {
			if (fqy) {
				return PAYMENT_FREQUENCY_DISPLAY[fqy];
			}

			/*
			if (fqy) {
				const { P1M, P3M, P12M } = FREQUENCY_API_CODE;

				switch(fqy) {
					case P1M:
						return '/ Month';

					case P3M:
						return '/ Quarter';

					case P12M:
						return '/ Year';
				}
			}
			*/
		});

		Vue.filter('subsTranslateFrequency', fqy => {
			if (fqy) {
				const { P1M, P3M, P12M } = FREQUENCY_API_CODE;

				switch(fqy) {
					case P1M:
						return 'Monthly';

					case P3M:
						return 'Quarterly';

					case P12M:
						return 'Yearly';
				}
			}
		});

		Vue.filter('showSubscriptionStatusText', status => {
			if (status) {
				switch (status) {
					case 'A':
					case 'ACTIVE':
						return 'ACTIVE';
					case 'CANCELLED':
						return 'CANCELLED';
					case 'I':
					case 'INACTIVE':
						return 'INACTIVE';
					case 'FOR_CANCELLATION':
							return 'FOR CANCELLATION';
					case "DELETED":
						return 'DELETED';
					case 'ENDED':
							return 'ENDED';
				}
			}
		});

		// Read more limit text
		Vue.filter('limitReadMore', (description, limit) => {
			if (description) {
				return description.length > limit ? description.substring(0, limit) + '...' : description.substring(0, limit);
			}
		});


		// translate pet age
		Vue.filter('petAge', age => {
			const ageList = { A: 'Adult', P: 'Puppy' }
			if (age) {
				return ageList[age];
			}
			return age;
		});

		Vue.filter('translateDogPurchaseStatus', status => {
			if (status) {
				return DOG_PURCHASE_STATUS[status] ? DOG_PURCHASE_STATUS[status] : `Unknown Status: ${status}`;
			}

			return `No status provided`;
		})

		Vue.filter('translatePuppyPurchaseStatus', status => {
			if (status) {
				return PUPPY_SELL_STATUS[status] ? PUPPY_SELL_STATUS[status] : `Unknown Status: ${status}`;
			}

			return `No status provided`;
		})
	}
}
